// extracted by mini-css-extract-plugin
export default {"modal":"IP-z","addItemButton":"JP-z","plusCircle":"KP-z","branchVisible":"LP-z"};